import { render, staticRenderFns } from "./HeartRateZoneIndividualChart.vue?vue&type=template&id=3c9945a2"
import script from "./HeartRateZoneIndividualChart.vue?vue&type=script&lang=js"
export * from "./HeartRateZoneIndividualChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports